module.exports = __webpack_public_path__ + "logo_48-a32949b7ef9008cbd2eb05c406b86a04.png";


//////////////////
// WEBPACK FOOTER
// ./assets/leagues/logo_48.png
// module id = 1138
// module chunks = 0 1